import React from 'react';
import PropTypes from 'prop-types';

import { BUCKET, FILE, FILE_ID, FILE_URL, FILE_URL_EXPIRES, MIMETYPE, NAME, ORIGINAL_NAME, OFFLINE } from 'store/medicalHistory';
import Images from 'components/MultiImage';
import { useAsyncState } from 'utils/useAsyncState';

import SearchableBox from './SearchableBox';

const MultiImage = ({ values, updateFile, deleteFile, loadingDelete, label, readMode }) => {
  const [searchId, setSearchId] = useAsyncState();

  return (
    <>
      <Images
        values={values}
        label={label}
        readMode={readMode}
        editable
        updateFile={updateFile}
        deleteFile={deleteFile}
        loadingDelete={loadingDelete}
        onSearch={setSearchId}
      />
      {searchId && <SearchableBox id={searchId} closeBox={setSearchId} />}
    </>
  );
};

MultiImage.defaultProps = {
  readMode: false,
  label: null,
  loadingDelete: false,
  updateFile: () => {},
  deleteFile: () => {},
};

MultiImage.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.shape({
      [FILE]: PropTypes.shape({
        [FILE_ID]: PropTypes.string.isRequired,
        [FILE_URL]: PropTypes.string,
        [FILE_URL_EXPIRES]: PropTypes.string,
        [BUCKET]: PropTypes.string.isRequired,
        [MIMETYPE]: PropTypes.string.isRequired,
        [NAME]: PropTypes.string.isRequired,
        [ORIGINAL_NAME]: PropTypes.string.isRequired,
        [OFFLINE]: PropTypes.bool,
      }).isRequired,
    }).isRequired
  ).isRequired,
  updateFile: PropTypes.func,
  deleteFile: PropTypes.func,
  label: PropTypes.string,
  readMode: PropTypes.bool,
  loadingDelete: PropTypes.bool,
};

export default MultiImage;
